export const UserSubscriptionsInfo = {
    title : "My Subscriptions",
    URL : '/user/subscriptions',
    noEventsMessage : "You don't have any subscriptions yet, would you like to add one?",
    noEventsLink : "/dashboard",
    noEventsTitleLink : "Go to events",

}